<div *ngIf="getDisplayMediaCount()"
     class="grid post-media"
     [class.post-media--interactive]="interactive"
     [ngClass]="{
       'one-item': getDisplayMediaCount() === 1,
       'three-items': getDisplayMediaCount() === 3,
       'post-media--with-video': getDisplayMediaCount() > 1 && hasDisplayVideoMedia()
     }">
  <ng-container [ngSwitch]="getDisplayMediaCount()">
    <ng-container *ngSwitchCase="1">
      <div class="col-12 p-0"
           [ngStyle]="imageContainerStyles(getDisplayMediaAt(0), getDisplayMediaCount())"
           (click)="openDisplayMedia($event, 0, firstMedia)">
        <app-media-view #firstMedia
                        [contain]="containImages"
                        [showBackdrop]="shouldShowBackdrop(getDisplayMediaAt(0))"
                        [mediaObject]="getDisplayMediaAt(0)"
                        [ratio]="1"
                        [priority]="priority"
                        [prewarm]="false"
                        [thumbnailOnly]="thumbnailOnly"
                        [deferLoading]="deferLoading">
        </app-media-view>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="2">
      <div class="col-6 p-0"
           [ngStyle]="imageContainerStyles(getDisplayMediaAt(0), getDisplayMediaCount())"
           (click)="openDisplayMedia($event, 0, firstMedia)">
        <app-media-view #firstMedia
                        [contain]="containImages"
                        [showBackdrop]="shouldShowBackdrop(getDisplayMediaAt(0))"
                        [mediaObject]="getDisplayMediaAt(0)"
                        [priority]="priority"
                        [prewarm]="false"
                        [thumbnailOnly]="thumbnailOnly"
                        [deferLoading]="deferLoading">
        </app-media-view>
      </div>
      <div class="col-6 p-0"
           [ngStyle]="imageContainerStyles(getDisplayMediaAt(1), getDisplayMediaCount())"
           (click)="openDisplayMedia($event, 1, secondMedia)">
        <app-media-view #secondMedia
                        [contain]="containImages"
                        [showBackdrop]="shouldShowBackdrop(getDisplayMediaAt(1))"
                        [mediaObject]="getDisplayMediaAt(1)"
                        [priority]="priority"
                        [prewarm]="false"
                        [thumbnailOnly]="thumbnailOnly"
                        [deferLoading]="deferLoading">
        </app-media-view>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="3">
      <div class="col-12 p-0"
           [ngStyle]="imageContainerStyles(getDisplayMediaAt(0), getDisplayMediaCount())"
           (click)="openDisplayMedia($event, 0, firstMedia)">
        <app-media-view #firstMedia
                        [contain]="containImages"
                        [showBackdrop]="shouldShowBackdrop(getDisplayMediaAt(0))"
                        [mediaObject]="getDisplayMediaAt(0)"
                        [priority]="priority"
                        [prewarm]="false"
                        [thumbnailOnly]="thumbnailOnly"
                        [deferLoading]="deferLoading">
        </app-media-view>
      </div>
      <div *ngFor="let item of getDisplayMediaSlice(1, getDisplayMediaCount()); let i = index"
           class="col-6 p-0"
           [ngStyle]="imageContainerStyles(item, getDisplayMediaCount())"
           (click)="openDisplayMedia($event, i + 1, object)">
        <app-media-view #object
                        [contain]="containImages"
                        [showBackdrop]="shouldShowBackdrop(item)"
                        [mediaObject]="item"
                        [priority]="priority"
                        [prewarm]="false"
                        [thumbnailOnly]="thumbnailOnly"
                        [deferLoading]="deferLoading">
        </app-media-view>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="4">
      <div *ngFor="let item of getDisplayMediaSlice(0, getDisplayMediaCount()); let i = index"
           class="col-6 p-0"
           [ngStyle]="imageContainerStyles(item, getDisplayMediaCount())"
           (click)="openDisplayMedia($event, i, object)">
        <app-media-view #object
                        [contain]="containImages"
                        [showBackdrop]="shouldShowBackdrop(item)"
                        [mediaObject]="item"
                        [priority]="priority"
                        [prewarm]="false"
                        [thumbnailOnly]="thumbnailOnly"
                        [deferLoading]="deferLoading">
        </app-media-view>
      </div>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <div class="col-6 p-0"
           [ngStyle]="imageContainerStyles(getDisplayMediaAt(0), getDisplayMediaCount())"
           (click)="openDisplayMedia($event, 0, firstMedia)">
        <app-media-view #firstMedia
                        [contain]="containImages"
                        [showBackdrop]="shouldShowBackdrop(getDisplayMediaAt(0))"
                        [mediaObject]="getDisplayMediaAt(0)"
                        [priority]="priority"
                        [prewarm]="false"
                        [thumbnailOnly]="thumbnailOnly"
                        [deferLoading]="deferLoading">
        </app-media-view>
      </div>
      <div class="col-6 p-0"
           [ngStyle]="imageContainerStyles(getDisplayMediaAt(1), getDisplayMediaCount())"
           (click)="openDisplayMedia($event, 1, secondMedia)">
        <app-media-view #secondMedia
                        [contain]="containImages"
                        [showBackdrop]="shouldShowBackdrop(getDisplayMediaAt(1))"
                        [mediaObject]="getDisplayMediaAt(1)"
                        [priority]="priority"
                        [prewarm]="false"
                        [thumbnailOnly]="thumbnailOnly"
                        [deferLoading]="deferLoading">
        </app-media-view>
      </div>
      <div *ngFor="let item of getDisplayMediaSlice(2, 5); let last = last; let i = index"
           class="col-4 p-0"
           [ngStyle]="imageContainerStyles(item, getDisplayMediaCount())"
           (click)="openDisplayMedia($event, i + 2, object)">
        <div class="post-media__more-overlay flex justify-content-center align-items-center"
             *ngIf="last && getHiddenMediaCount(getDisplayMediaCount())">
          <span style="font-size: 3rem;">+{{ getHiddenMediaCount(getDisplayMediaCount()) }}</span>
        </div>
        <app-media-view #object
                        [contain]="containImages"
                        [showBackdrop]="shouldShowBackdrop(item)"
                        [mediaObject]="item"
                        [priority]="priority"
                        [prewarm]="false"
                        [thumbnailOnly]="thumbnailOnly"
                        [deferLoading]="deferLoading">
        </app-media-view>
      </div>
    </ng-container>
  </ng-container>
</div>
